const readEnv = (key: keyof ImportMetaEnv): string | undefined => {
  const value = import.meta.env[key];

  return typeof value === "string" && value.length > 0 ? value : undefined;
};

export const appEnv = {
  apiVersion: readEnv("VITE_API_VERSION"),
  apiUrl: readEnv("VITE_API_URL"),
  storageCurrentSiteKey: readEnv("VITE_STORAGE_CURRENT_SITE_KEY") ?? "SelectedSite",
  storageTokenKey: readEnv("VITE_STORAGE_TOKEN_KEY") ?? "SBCmsToken"
} as const;
